

import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Select, MenuItem, Menu } from "@mui/material";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage } from "react-icons/md";

interface PaginationProps {
  projectsPerPage: number;
  totalProjects: number;
  paginate: (pageNumber: number) => void;
  currentPage: number;
  onRowsPerPageChange: (rows: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  projectsPerPage,
  totalProjects,
  paginate,
  currentPage,
  onRowsPerPageChange,
}) => {
  const [inputValue, setInputValue] = useState(currentPage.toString());
  const [rowsPerPage, setRowsPerPage] = useState(projectsPerPage);
  const totalPages = Math.ceil(totalProjects / rowsPerPage);

  const [anchorPageMenu, setAnchorPageMenu] = useState<null | HTMLElement>(null);

  const handleOpenPageMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorPageMenu(event.currentTarget);
  };

  const handleClosePageMenu = () => {
    setAnchorPageMenu(null);
  };

  const handleSelectPage = (pageNum: number) => {
    paginate(pageNum);
    handleClosePageMenu();
  };

  useEffect(() => {
    setInputValue(currentPage.toString());
  }, [currentPage]);

  const handleRowsChange = (event: any) => {
    const value = parseInt(event.target.value, 10);
    setRowsPerPage(value);
    onRowsPerPageChange(value);
    paginate(1); // Reset to first page
  };

  const handleNext = () => {
    if (currentPage < totalPages) paginate(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) paginate(currentPage - 1);
  };

  const handleFirst = () => {
    if (currentPage > 1) paginate(1);
  };

  const handleLast = () => {
    if (currentPage < totalPages) paginate(totalPages);
  };

  //   return (
  //     <Box
  //       display="flex"
  //       alignItems="center"
  //       justifyContent="space-between"
  //       p={0}
  //       style={{ translate: "0px -10px" }}
  //       bgcolor="#F5F5F5"
  //       borderTop={"1px solid #ccc"}
  //       mt={-2.5}
  //     >
  //       <Box display="flex" alignItems="center" gap={1} ml={2}>
  //         <Typography
  //           style={{
  //             color: "rgb(94, 93, 93)",
  //             fontFamily: "system-ui",
  //           }}
  //         >
  //           Rows per page:
  //         </Typography>
  //         <Select
  //           value={rowsPerPage}
  //           onChange={handleRowsChange}
  //           size="small"
  //           // style={{ fontSize: "0.85rem" }}

  //           sx={{
  //             fontSize: "0.85rem",
  //             "& .MuiOutlinedInput-notchedOutline": {
  //               borderColor: "black",
  //             },
  //             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  //               borderColor: "#ddd",
  //             },
  //             "&:hover .MuiOutlinedInput-notchedOutline": {
  //               borderColor: "#ccc",
  //             },
  //           }}
  //         >
  //           {[5, 10, 25, 50, 100].map((num) => (
  //             <MenuItem key={num} value={num}>
  //               {num}
  //             </MenuItem>
  //           ))}
  //         </Select>
  //       </Box>

  //       <Typography
  //         style={{
  //           color: "rgb(94, 93, 93)",
  //           translate: "30rem 6px",
  //           whiteSpace: "nowrap",
  //           fontFamily: "system-ui",
  //         }}
  //       >
  //         Page {currentPage} of {totalPages}
  //       </Typography>

  //       <IconButton
  //         onClick={handlePrev}
  //         disabled={currentPage === 1}
  //         style={{ marginLeft: "30rem", marginTop: "0.8rem" }}
  //       >
  //         <IoMdArrowDropleft style={{ fontSize: "2rem", color: "black" }} />
  //       </IconButton>
  //       <IconButton
  //         onClick={handleNext}
  //         disabled={currentPage === totalPages}
  //         style={{ marginTop: "0.8rem" }}
  //       >
  //         <MdOutlineArrowRight style={{ fontSize: "2.3rem", color: "black" }} />
  //       </IconButton>
  //     </Box>
  //   );
  // };

  const startItem = (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalProjects);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 16px",
        backgroundColor: "#F5F5F5",
        minHeight: "50px",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.08)",
      }}
    >
      {/* Left: Rows per page */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <span style={{ color: "#2d3748", fontFamily: "system-ui", fontSize: "0.9rem", fontWeight: "600" }}>
          Rows per page:
        </span>
        <select
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{
            fontSize: "0.9rem",
            border: "1px solid #5a5a5a",
            padding: "6px 12px",
            borderRadius: "6px",
            backgroundColor: "#fff",
            cursor: "pointer",
            outline: "none",
            fontWeight: "600",
            color: "#5a5a5a",
          }}
        >
          {[5, 10, 25, 50, 75, 100].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>
      </div>

    {/* Center: Showing info */}
    <span
      style={{
        color: "#5e5d5d",
        fontFamily: "system-ui",
        fontSize: "0.875rem",
        whiteSpace: "nowrap",
      }}
    >
      Showing {startItem}-{endItem} of {totalProjects} items
    </span>

      {/* Right: Page info and navigation */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <span
          style={{
            color: "#2d3748",
            fontFamily: "system-ui",
            fontSize: "0.9rem",
            whiteSpace: "nowrap",
            fontWeight: "600",
          }}
        >
          Page {currentPage} of {totalPages}
        </span>

        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <button
            onClick={handleFirst}
            disabled={currentPage === 1}
            style={{
              background: currentPage === 1 ? "#f8f9fa" : "#4a4a4a",
              border: currentPage === 1 ? "1px solid #e0e0e0" : "1px solid #4a4a4a",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              transition: "all 0.2s ease",
              minWidth: "32px",
              minHeight: "32px",
            }}
            aria-label="First page"
            title="First page"
          >
            <MdFirstPage style={{ fontSize: "1.1rem", color: currentPage === 1 ? "#c0c0c0" : "#ffffff" }} />
          </button>

          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            style={{
              background: currentPage === 1 ? "#f8f9fa" : "#4a4a4a",
              border: currentPage === 1 ? "1px solid #e0e0e0" : "1px solid #4a4a4a",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              transition: "all 0.2s ease",
              minWidth: "32px",
              minHeight: "32px",
            }}
            aria-label="Previous page"
          >
            <MdOutlineKeyboardArrowLeft style={{ fontSize: "1.15rem", color: currentPage === 1 ? "#c0c0c0" : "#ffffff" }} />
          </button>

          {/* Page Number Dropdown - Vertical List */}
          <button
            onClick={handleOpenPageMenu}
            style={{
              background: "#fff",
              border: "1px solid #d0d0d0",
              borderRadius: "5px",
              padding: "5px 10px",
              margin: "0 3px",
              cursor: "pointer",
              fontSize: "0.875rem",
              fontFamily: "system-ui",
              color: "#2d3748",
              minWidth: "50px",
              minHeight: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              fontWeight: "600",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#f5f5f5";
              e.currentTarget.style.borderColor = "#b0b0b0";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.borderColor = "#d0d0d0";
            }}
            aria-label="Select page"
            title="Select page number"
          >
            {currentPage}
            <span style={{ fontSize: "0.55rem", color: "#6b7280" }}>▼</span>
          </button>

          <Menu
            anchorEl={anchorPageMenu}
            open={Boolean(anchorPageMenu)}
            onClose={handleClosePageMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              style: {
                maxHeight: 280,
                width: "120px",
                marginTop: "4px",
                overflow: "auto",
              },
              sx: {
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#c1c1c1",
                  borderRadius: "3px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#a8a8a8",
                },
              },
            }}
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
              <MenuItem
                key={pageNum}
                onClick={() => handleSelectPage(pageNum)}
                selected={pageNum === currentPage}
                style={{
                  fontSize: "0.875rem",
                  fontFamily: "system-ui",
                  padding: "6px 16px",
                  justifyContent: "flex-start",
                  backgroundColor: pageNum === currentPage ? "#d5d5d5" : "transparent",
                  color: "#333",
                  fontWeight: pageNum === currentPage ? 600 : 400,
                }}
              >
                Page {pageNum}
              </MenuItem>
            ))}
          </Menu>

          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            style={{
              background: currentPage === totalPages ? "#f8f9fa" : "#4a4a4a",
              border: currentPage === totalPages ? "1px solid #e0e0e0" : "1px solid #4a4a4a",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              transition: "all 0.2s ease",
              minWidth: "32px",
              minHeight: "32px",
            }}
            aria-label="Next page"
          >
            <MdOutlineKeyboardArrowRight style={{ fontSize: "1.15rem", color: currentPage === totalPages ? "#c0c0c0" : "#ffffff" }} />
          </button>

          <button
            onClick={handleLast}
            disabled={currentPage === totalPages}
            style={{
              background: currentPage === totalPages ? "#f8f9fa" : "#4a4a4a",
              border: currentPage === totalPages ? "1px solid #e0e0e0" : "1px solid #4a4a4a",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              padding: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              transition: "all 0.2s ease",
              minWidth: "32px",
              minHeight: "32px",
            }}
            aria-label="Last page"
            title="Last page"
          >
            <MdLastPage style={{ fontSize: "1.1rem", color: currentPage === totalPages ? "#c0c0c0" : "#ffffff" }} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Pagination;
